<app-ui-main-menu>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Consulta de contas e planos</mat-card-title>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content>
      <div class="actions col-12">
        <form
          [formGroup]="filters"
          class="col-12 filters row"
          (ngSubmit)="onSearch()"
        >
          <div class="row">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Buscar por nome da conta</mat-label>
              <input
                matInput
                formControlName="accountName"
                (keyup.enter)="onSearch()"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="status-field">
              <mat-label>Filtrar por Status</mat-label>
              <mat-select
                formControlName="status"
                (selectionChange)="onChangeStatusFilter()"
              >
                <mat-option *ngFor="let s of statusType" [value]="s.value">{{
                  s.label
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>E-mail da conta</mat-label>
              <input
                matInput
                formControlName="accountEmail"
                (keyup.enter)="onSearch()"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="status-field">
              <mat-label>Gateway</mat-label>
              <mat-select
                formControlName="gateway"
                (selectionChange)="onChangeStatusFilter()"
              >
                <mat-option value="GURU"> Digital Manager Guru </mat-option>
                <mat-option value="IUGU"> IUGU </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              class="col-xl-3 col-lg-4 col-md-6 col-sm-12"
            >
              <mat-label>Periodo de avaliação</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input
                  matStartDate
                  placeholder="Data inicial"
                  formControlName="fromFinishedAt"
                />
                <input
                  matEndDate
                  placeholder="Data final"
                  formControlName="toFinishedAt"
                />
              </mat-date-range-input>

              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>

          <div class="options row">
            <button
              class="col-2"
              mat-flat-button
              aria-label="Limpar Filtros"
              type="button"
              (click)="clearFilter()"
            >
              <span>Limpar Filtros</span>
            </button>

            <button mat-flat-button color="primary" type="submit">
              Pesquisar
            </button>
          </div>
        </form>
      </div>

      <app-loading *ngIf="loading"></app-loading>
      <ng-container *ngIf="!loading">
        <div *ngIf="dataSource.data.length === 0">
          <h3>Nenhum conteúdo disponível</h3>
        </div>

        <div *ngIf="dataSource.data.length > 0">
          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="account">
              <th mat-header-cell *matHeaderCellDef>Nome da conta</th>
              <td mat-cell *matCellDef="let element">
                {{ element.accountName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="plan">
              <th mat-header-cell *matHeaderCellDef>Plano vigente</th>
              <td mat-cell *matCellDef="let element">
                {{ element.planName || "-" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element">
                {{ element.status || "-" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startedAt">
              <th mat-header-cell *matHeaderCellDef>Início</th>
              <td mat-cell *matCellDef="let element">
                {{
                  element.startedAt
                    ? dateFormat.usaFromBRString(element.startedAt)
                    : "-"
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="finishedAt">
              <th mat-header-cell *matHeaderCellDef>Final</th>
              <td mat-cell *matCellDef="let element">
                {{
                  element.finishedAt
                    ? dateFormat.usaFromBRString(element.finishedAt)
                    : "-"
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="gateway">
              <th mat-header-cell *matHeaderCellDef>-</th>
              <td mat-cell *matCellDef="let element">
                <ng-container
                  *ngIf="
                    gatewayLinkGenerate(
                      element.digitalManagerContactId
                    ) as gateway
                  "
                >
                  <!-- Se existir link, mostra como <a> -->
                  <ng-container *ngIf="gateway.link; else noLink">
                    <a
                      [href]="gateway.link"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="gateway-link"
                    >
                      {{ gateway.label }}
                    </a>
                  </ng-container>

                  <!-- Caso não exista link, apenas exibe o label -->
                  <ng-template #noLink>
                    <span class="gateway-label">{{ gateway.label }}</span>
                  </ng-template>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>Ações</th>
              <td mat-cell *matCellDef="let element" class="actions">
                <button
                  mat-mini-fab
                  color="primary"
                  matTooltip="Gerar link de planos"
                  (click)="openPlanModal(element)"
                >
                  <fa-icon icon="link"></fa-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <mat-paginator
            [length]="total"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50, 100, 500]"
            (page)="onSearch($event)"
          >
          </mat-paginator>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>
